import _typeof from "@babel/runtime-corejs3/helpers/typeof";import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";import _createClass from "@babel/runtime-corejs3/helpers/createClass";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";import _Number$isNaN from "@babel/runtime-corejs3/core-js-stable/number/is-nan";import _Number$isInteger from "@babel/runtime-corejs3/core-js-stable/number/is-integer";import { action, makeObservable, observable } from 'mobx';








export var BasicFormControl = /*#__PURE__*/function () {



























































  function BasicFormControl(initialValue, params) {_classCallCheck(this, BasicFormControl);_defineProperty(this, "optional", false);_defineProperty(this, "trim", false);_defineProperty(this, "secondLevelValidationMessage", '');_defineProperty(this, "disabled", false);
    this.initialValue = initialValue;
    this.value = initialValue;
    this.optional = (params === null || params === void 0 ? void 0 : params.optional) || false;
    this.disabled = (params === null || params === void 0 ? void 0 : params.disabled) || false;
    this.trim = (params === null || params === void 0 ? void 0 : _trimInstanceProperty(params)) || false;

    makeObservable(this, {
      value: observable,
      disabled: observable,
      optional: observable,
      trim: observable,
      secondLevelValidationMessage: observable,
      setOptionalFlag: action.bound,
      overrideValue: action.bound,
      disableControl: action.bound,
      enableControl: action.bound
    });
  }_createClass(BasicFormControl, [{ key: "setOptionalFlag", value: function setOptionalFlag(optional) {this.optional = optional;} }, { key: "overrideValue", value: function overrideValue(value) {this.value = value;} }, { key: "disableControl", value: function disableControl() {this.disabled = true;this.value = this.initialValue;} }, { key: "enableControl", value: function enableControl() {this.disabled = false;} // This method used when the optional flag is false but no validations provided. It checks the FormControl
    // value type and validate it.
    // If the value type is 'string' - returns true for any value that is not empty string;
    // If the value type is 'number' - returns true for any value that is not 'NaN';
    // For all the other values returns true;
  }, { key: "isBasicValidationPassed", value: function isBasicValidationPassed() {var _context;switch (_typeof(this.value)) {case 'string':return _trimInstanceProperty(_context = this.value).call(_context).length > 0;case 'number':return !_Number$isNaN(this.value) || _Number$isInteger(this.value);default:return true;}} }, { key: "skipValidation", value: function skipValidation() {// If this FormControl has html5 'disabled' attribute set to true - returns no validations.
      if (this.disabled) {return true;} // No validations if the field is optional and has it's initial value.
      return this.optional && String(this.value) === String(this.initialValue);} }]);return BasicFormControl;}();
//# sourceMappingURL=BasicFormControl.js.map